/**
 * GENERATED FILE — do not edit.
 *
 * Written by scripts/generate-blog-index.js from src/data/blogPosts.js, which
 * is the source of truth. Listing metadata only: no sections, faqs or
 * relatedLinks, so importing this does not pull the ~735 KB of article bodies
 * into the entry chunk. Run `npm run blog-index` after editing blogPosts.js
 * (prebuild and prestart already do).
 */

export const blogIndex = [
  {
    "slug": "how-to-buy-used-taxi-india",
    "title": "How to Buy a Used Taxi in India: Complete Guide 2026",
    "excerpt": "Buying a used taxi in India involves more than just checking the price. This complete guide covers everything — from vehicle inspection to RC verification — so you make a confident purchase.",
    "category": "Buying Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-03-10",
    "readTime": "8 min"
  },
  {
    "slug": "how-to-sell-taxi-fast-india",
    "title": "How to Sell Your Taxi Fast in India: Seller's Complete Guide",
    "excerpt": "Selling a taxi in India is not the same as selling a personal car. Get the pricing right, documents ready, and list on the right platform to sell fast and at the best price.",
    "category": "Selling Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-03-12",
    "readTime": "6 min"
  },
  {
    "slug": "cng-vs-diesel-taxi-india",
    "title": "CNG vs Diesel Taxi in India: Which is Better for You?",
    "excerpt": "Choosing between CNG and diesel for your taxi can mean a difference of ₹50,000+ per year in running costs. Here's the complete comparison to help you make the right call.",
    "category": "Vehicle Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-03-13",
    "readTime": "7 min"
  },
  {
    "slug": "best-cars-ola-uber-india-2026",
    "title": "Ola & Uber Car List 2026: Every Eligible Sedan, SUV & 7-Seater in India",
    "excerpt": "Choosing the right car for Ola/Uber can make or break your earnings. We rank the 8 best app-cab vehicles in India for 2026 based on running costs, passenger comfort, approval rates, and resale value.",
    "category": "Vehicle Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-03-14",
    "readTime": "9 min"
  },
  {
    "slug": "rc-document-check-before-buying-taxi",
    "title": "How to Verify RC and Documents Before Buying a Used Taxi",
    "excerpt": "Document fraud is one of the biggest risks when buying a used taxi in India. Use this step-by-step RC verification checklist to protect yourself from scams and legal trouble.",
    "category": "Buying Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-03-15",
    "readTime": "6 min"
  },
  {
    "slug": "buy-taxi-delhi-guide",
    "title": "Buy a Taxi in Delhi: Complete Guide to Used Taxis in Delhi NCR",
    "excerpt": "Delhi NCR is India's largest commercial vehicle market. This guide covers everything specific to buying a taxi in Delhi — CNG rules, permit requirements, price ranges, and more.",
    "category": "City Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-03-16",
    "readTime": "7 min"
  },
  {
    "slug": "fleet-operator-guide-india",
    "title": "Fleet Operator's Guide: Build a Profitable Taxi Fleet in India",
    "excerpt": "From 5 vehicles to 50, building a profitable taxi fleet in India requires the right vehicles, smart financing, and efficient operations. Here's the complete playbook for fleet operators.",
    "category": "Business Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-03-17",
    "readTime": "10 min"
  },
  {
    "slug": "electric-vehicles-taxi-india",
    "title": "Electric Vehicles for Taxi Operations in India: Is It Worth It in 2026?",
    "excerpt": "Electric taxis have the lowest per-km running cost in India — just ₹1–1.5/km vs ₹4+ for CNG. But charging infrastructure and upfront cost remain challenges. Here's the full picture for 2026.",
    "category": "Vehicle Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-03-18",
    "readTime": "8 min"
  },
  {
    "slug": "used-swift-dzire-taxi-review",
    "title": "Used Maruti Swift Dzire for Taxi: Complete Review & Buying Guide",
    "excerpt": "The Maruti Swift Dzire is India's most popular taxi. Over a million units operate as commercial vehicles across the country. But is a used one the right buy for your taxi operations? Here's the complete breakdown.",
    "category": "Vehicle Review",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-03-19",
    "readTime": "7 min"
  },
  {
    "slug": "commercial-vehicle-loan-guide-india",
    "title": "How to Get a Commercial Vehicle Loan for Buying a Taxi in India",
    "excerpt": "A commercial vehicle loan can help you buy your taxi with as little as 10–20% down payment. This guide compares top banks, interest rates, eligibility criteria, and tips to get approved faster.",
    "category": "Finance Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-03-20",
    "readTime": "8 min"
  },
  {
    "slug": "buy-innova-for-taxi-india",
    "title": "How to Buy a Toyota Innova for Taxi Use in India: Complete Guide",
    "excerpt": "The Toyota Innova remains India's most trusted outstation and premium taxi. Here's everything you need to know before buying one for commercial use.",
    "category": "Vehicle Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-03-22",
    "readTime": "7 min"
  },
  {
    "slug": "taxi-business-profit-india-2026",
    "title": "Is the Taxi Business Profitable in India in 2026? Real Numbers",
    "excerpt": "The taxi business in India can generate ₹15,000–60,000 net profit per month per vehicle — if you make the right choices on vehicle, city, and operation model. Here are the real numbers.",
    "category": "Business Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-03-23",
    "readTime": "9 min"
  },
  {
    "slug": "commercial-vehicle-insurance-india",
    "title": "Commercial Vehicle Insurance in India: Complete Guide for Taxi Owners",
    "excerpt": "Commercial vehicle insurance for taxis is mandatory in India — but most taxi owners are under-insured or paying too much. Here's how to get the right coverage at the right price.",
    "category": "Finance & Legal",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-03-24",
    "readTime": "8 min"
  },
  {
    "id": 1,
    "slug": "buy-cng-taxi-delhi-under-3-lakh",
    "title": "Buy CNG Taxi in Delhi Under ₹3 Lakh – Best Options 2026",
    "excerpt": "A budget of ₹3 lakh can get you a reliable CNG taxi in Delhi if you know what to look for. Here are the best options and key checks for 2026.",
    "category": "Buying Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-04-05",
    "readTime": "6 min read"
  },
  {
    "id": 2,
    "slug": "sell-old-taxi-delhi-fast",
    "title": "How to Sell Your Old Taxi in Delhi Fast – Step by Step 2026",
    "excerpt": "Selling a taxi in Delhi requires the right price, clean documents, and the right platform. Follow this step-by-step guide to sell your vehicle in days, not months.",
    "category": "Selling Tips",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-04-05",
    "readTime": "5 min read"
  },
  {
    "id": 3,
    "slug": "delhi-taxi-permit-2026",
    "title": "Delhi Taxi Permit Rules 2026 – Tourist, Contract & Radio Cab Guide",
    "excerpt": "Operating a taxi in Delhi without the right permit can result in heavy fines and seizure. Here is a complete breakdown of all taxi permit types and rules in Delhi for 2026.",
    "category": "RTO & Permits",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-04-05",
    "readTime": "7 min read"
  },
  {
    "id": 4,
    "slug": "ola-uber-registration-delhi",
    "title": "How to Register on Ola & Uber in Delhi 2026 – Full Process",
    "excerpt": "Registering on Ola or Uber in Delhi takes 3–7 days if your documents are in order. Here is exactly what you need — vehicle, licence, and permit requirements for 2026.",
    "category": "Business Tips",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-04-05",
    "readTime": "7 min read"
  },
  {
    "id": 5,
    "slug": "used-maruti-eeco-taxi-delhi",
    "title": "Used Maruti Suzuki Eeco Taxi for Sale in Delhi – Complete Guide 2026",
    "excerpt": "The Maruti Suzuki Eeco is one of Delhi's most popular shared taxis and family cabs. Here's everything you need to know before buying a used one in 2026.",
    "category": "Vehicle Review",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-04-05",
    "readTime": "6 min read"
  },
  {
    "id": 6,
    "slug": "taxi-business-delhi-2026",
    "title": "Start a Taxi Business in Delhi in 2026 – Complete Step-by-Step Guide",
    "excerpt": "Starting a taxi business in Delhi in 2026 requires the right vehicle, permits, and strategy. This guide covers everything from ₹2 lakh to ₹20 lakh investment levels.",
    "category": "Business Tips",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-04-05",
    "readTime": "8 min read"
  },
  {
    "id": 7,
    "slug": "buy-taxi-noida",
    "title": "Buy Taxi in Noida 2026 – Used Taxis & Commercial Vehicles for Sale",
    "excerpt": "Noida's rapidly growing IT and commercial sector makes it one of NCR's most active taxi markets. Here's where to find used taxis in Noida at the best prices in 2026.",
    "category": "City Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-04-05",
    "readTime": "5 min read"
  },
  {
    "id": 8,
    "slug": "buy-taxi-gurgaon",
    "title": "Buy Taxi in Gurgaon 2026 – Used Taxis for Sale in Gurugram",
    "excerpt": "Gurgaon is one of NCR's most premium taxi markets with strong corporate and airport transfer demand. Here's a complete guide to buying a taxi in Gurugram in 2026.",
    "category": "City Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-04-05",
    "readTime": "5 min read"
  },
  {
    "id": 9,
    "slug": "how-to-inspect-used-taxi-delhi",
    "title": "How to Inspect a Used Taxi Before Buying in Delhi – Complete Checklist",
    "excerpt": "A thorough pre-purchase inspection can save you lakhs on a used taxi in Delhi. Use this checklist to avoid hidden problems and bad deals.",
    "category": "Buying Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-04-05",
    "readTime": "7 min read"
  },
  {
    "id": 10,
    "slug": "delhi-rc-transfer-guide",
    "title": "How to Transfer RC of a Taxi in Delhi – Complete Step-by-Step Process 2026",
    "excerpt": "RC transfer for a commercial taxi in Delhi must be completed within 30 days of purchase. Here is the exact process, documents, and fees for 2026.",
    "category": "Insurance & Legal",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-04-05",
    "readTime": "6 min read"
  },
  {
    "id": 11,
    "slug": "buy-swift-dzire-taxi-delhi",
    "title": "Buy Used Swift Dzire Taxi in Delhi – Price & Inspection Tips 2026",
    "excerpt": "The Swift Dzire is Delhi's most popular taxi sedan. Here is a complete price and inspection guide for buying a used Dzire taxi in 2026.",
    "category": "Buying Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-04-06",
    "readTime": "6 min read"
  },
  {
    "id": 12,
    "slug": "commercial-vehicle-insurance-delhi",
    "title": "Commercial Vehicle Insurance in Delhi – Best Plans & Cost 2026",
    "excerpt": "Commercial vehicle insurance is mandatory for all taxis in Delhi. Here is a complete guide to the best plans, costs, and what to look for in 2026.",
    "category": "Insurance & Legal",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-04-06",
    "readTime": "6 min read"
  },
  {
    "id": 13,
    "slug": "petrol-vs-cng-taxi-delhi",
    "title": "Petrol vs CNG Taxi in Delhi – Which Is More Profitable in 2026?",
    "excerpt": "With petrol at ₹105/litre and CNG at ₹95/kg in Delhi, the fuel choice for your taxi can make a ₹8,000–₹12,000 monthly difference. Here is a full comparison for 2026.",
    "category": "Business Tips",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-04-06",
    "readTime": "6 min read"
  },
  {
    "id": 14,
    "slug": "taxi-loan-delhi-2026",
    "title": "Taxi Loan in Delhi 2026 – Banks, Interest Rates & How to Apply",
    "excerpt": "Financing a taxi in Delhi is easier than most people think. Here are the best loan options, interest rates, and step-by-step application process for 2026.",
    "category": "Business Tips",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-04-06",
    "readTime": "7 min read"
  },
  {
    "id": 15,
    "slug": "buy-taxi-faridabad",
    "title": "Buy Taxi in Faridabad 2026 – Commercial Vehicles for Sale",
    "excerpt": "Faridabad is Haryana's largest industrial city and a growing taxi market in NCR. Here is a complete guide to buying a taxi in Faridabad in 2026.",
    "category": "City Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-04-06",
    "readTime": "5 min read"
  },
  {
    "id": 16,
    "slug": "buy-taxi-ghaziabad",
    "title": "Buy Taxi in Ghaziabad 2026 – Used Taxis & Cabs for Sale",
    "excerpt": "Ghaziabad is one of NCR's fastest-growing markets for taxi operators. Here's everything you need to know about buying a taxi in Ghaziabad in 2026.",
    "category": "City Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-04-06",
    "readTime": "5 min read"
  },
  {
    "id": 17,
    "slug": "fleet-taxi-delhi",
    "title": "How to Build a Taxi Fleet in Delhi – Fleet Business Guide 2026",
    "excerpt": "A taxi fleet in Delhi can generate ₹1–3 lakh net monthly profit with 5–10 vehicles. Here is a complete guide to building and running a fleet business in 2026.",
    "category": "Business Tips",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-04-06",
    "readTime": "8 min read"
  },
  {
    "id": 18,
    "slug": "second-hand-auto-rickshaw-delhi",
    "title": "Second Hand Auto Rickshaw for Sale in Delhi – Price & Complete Guide 2026",
    "excerpt": "Delhi has over 1 lakh registered auto rickshaws. If you're looking to buy a second-hand CNG auto in Delhi, here is everything you need to know about price, permit, and process in 2026.",
    "category": "Buying Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-04-06",
    "readTime": "6 min read"
  },
  {
    "id": 19,
    "slug": "buy-innova-crysta-taxi-delhi",
    "title": "Buy Innova Crysta Taxi in Delhi – Price, Inspection & Best Deals 2026",
    "excerpt": "The Toyota Innova Crysta is Delhi's most popular premium taxi. Here is a complete price guide and inspection checklist before you invest in one for 2026.",
    "category": "Buying Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-04-06",
    "readTime": "7 min read"
  },
  {
    "id": 20,
    "slug": "delhi-taxi-route-earnings",
    "title": "Best Delhi Routes for Taxi Drivers – Maximize Daily Earnings 2026",
    "excerpt": "Smart Delhi taxi drivers know that route selection determines daily earnings. Here are the highest-earning routes and zones in Delhi for 2026.",
    "category": "Business Tips",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-04-06",
    "readTime": "6 min read"
  },
  {
    "id": 21,
    "slug": "electric-taxi-delhi-2026",
    "title": "Electric Taxi Options in Delhi 2026 – EV Cabs for Drivers",
    "excerpt": "Delhi is India's fastest-growing EV market. Electric taxis offer ₹1.5–2.5 per km running costs vs ₹3.5–7 for CNG/diesel. Here is a complete guide for Delhi drivers in 2026.",
    "category": "Buying Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-04-07",
    "readTime": "7 min read"
  },
  {
    "id": 22,
    "slug": "used-ertiga-taxi-delhi",
    "title": "Used Maruti Ertiga Taxi for Sale in Delhi – Buyer's Guide 2026",
    "excerpt": "The Maruti Ertiga is Delhi's favourite 7-seater family cab and corporate shuttle. Here is a complete guide to buying a used Ertiga for taxi use in 2026.",
    "category": "Vehicle Review",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-04-07",
    "readTime": "6 min read"
  },
  {
    "id": 23,
    "slug": "best-used-taxi-delhi-2026",
    "title": "Best Used Taxis to Buy in Delhi in 2026 – Top Picks by Category",
    "excerpt": "Choosing the right used taxi in Delhi depends on your budget, route, and business model. Here are the top picks for every category in 2026.",
    "category": "Buying Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-04-07",
    "readTime": "7 min read"
  },
  {
    "id": 24,
    "slug": "buy-tempo-traveller-delhi",
    "title": "Buy Used Tempo Traveller in Delhi – Tourist Taxi Complete Guide 2026",
    "excerpt": "A Tempo Traveller in Delhi can earn ₹45,000–₹80,000 per month on tourist routes and corporate contracts. Here is your complete buying guide for 2026.",
    "category": "Buying Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-04-07",
    "readTime": "7 min read"
  },
  {
    "id": 25,
    "slug": "sell-commercial-vehicle-delhi",
    "title": "Sell Your Commercial Vehicle in Delhi – Best Platforms & Process 2026",
    "excerpt": "Selling a commercial vehicle in Delhi requires the right platform and proper paperwork. Here is how to sell your taxi, van, or bus fast and at the best price.",
    "category": "Selling Tips",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-04-07",
    "readTime": "6 min read"
  },
  {
    "id": 26,
    "slug": "taxi-valuation-delhi",
    "title": "How Much Is My Taxi Worth in Delhi? Free Valuation Guide 2026",
    "excerpt": "Not sure what your taxi is worth in Delhi? This guide walks through the exact factors that determine commercial vehicle value and how to estimate it accurately in 2026.",
    "category": "Selling Tips",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-04-07",
    "readTime": "6 min read"
  },
  {
    "id": 27,
    "slug": "delhi-cng-kit-fitting-taxi",
    "title": "CNG Kit Fitting for Taxi in Delhi – Cost, Rules & Best Centres 2026",
    "excerpt": "Converting your taxi to CNG in Delhi can save ₹8,000–₹12,000 per month in fuel costs. Here's everything you need to know about the CNG kit fitting process in 2026.",
    "category": "Business Tips",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-04-07",
    "readTime": "6 min read"
  },
  {
    "id": 28,
    "slug": "commercial-vehicle-fitness-delhi",
    "title": "Fitness Certificate for Commercial Vehicles in Delhi – Complete Guide 2026",
    "excerpt": "A valid fitness certificate is mandatory for all commercial taxis in Delhi. Here is a complete guide to obtaining and renewing it in 2026.",
    "category": "Insurance & Legal",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-04-07",
    "readTime": "6 min read"
  },
  {
    "id": 29,
    "slug": "delhi-ncr-taxi-market-2026",
    "title": "Delhi NCR Taxi Market 2026 – Prices, Trends & Best Buys",
    "excerpt": "The Delhi NCR taxi market in 2026 is seeing growing demand for CNG and electric vehicles. Here is a complete market overview with prices, trends, and buying opportunities.",
    "category": "City Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-04-07",
    "readTime": "7 min read"
  },
  {
    "id": 30,
    "slug": "buy-taxi-online-india",
    "title": "Buy Taxi Online in India 2026 – How to Find Verified Used Taxis",
    "excerpt": "Buying a taxi online in India is now faster and safer than ever — if you know where to look and what to check. Here is the complete guide for 2026.",
    "category": "Buying Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-04-12",
    "readTime": "6 min read"
  },
  {
    "id": 31,
    "slug": "sell-taxi-online-india",
    "title": "How to Sell Your Taxi Online in India 2026 – Get the Best Price Fast",
    "excerpt": "Selling a taxi online in India is the fastest way to reach serious buyers in 2026. Here is a complete guide to getting the best price quickly.",
    "category": "Selling Tips",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-04-12",
    "readTime": "6 min read"
  },
  {
    "id": 32,
    "slug": "used-taxi-for-sale-india",
    "title": "Used Taxi for Sale in India 2026 – Prices by City & Best Models",
    "excerpt": "Looking for a used taxi for sale in India? Here are the best deals by city, top models, and what to check before buying in 2026.",
    "category": "Buying Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-04-12",
    "readTime": "7 min read"
  },
  {
    "id": 33,
    "slug": "used-taxi-marketplace-india",
    "title": "India's Used Taxi Marketplace – Buy & Sell Taxis Online 2026",
    "excerpt": "Buy Sell Taxi is a used taxi marketplace built specifically for taxi operators, fleet owners, and commercial vehicle buyers and sellers.",
    "category": "Business Tips",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-04-12",
    "readTime": "5 min read"
  },
  {
    "slug": "innova-crysta-resale-value-delhi-2026",
    "title": "Toyota Innova Crysta Commercial Resale Value Delhi 2026 — What to Expect",
    "excerpt": "The Toyota Innova Crysta holds its commercial resale value better than almost any other taxi in India. Here is the real Delhi market data for 2026.",
    "category": "Market Insights",
    "author": "Aditya Kumar",
    "publishedAt": "2026-05-01",
    "readTime": "6 min"
  },
  {
    "slug": "fortuner-private-to-commercial-conversion-delhi",
    "title": "Cost of Converting Private Toyota Fortuner to Commercial Taxi in Delhi 2026",
    "excerpt": "Converting a private Fortuner to a commercial taxi in Delhi is possible but involves RTO approvals, fees, and a fitness inspection. Here is exactly what it costs and how long it takes.",
    "category": "RTO & Permits",
    "author": "Aditya Kumar",
    "publishedAt": "2026-05-02",
    "readTime": "7 min"
  },
  {
    "slug": "fortuner-vs-innova-crysta-taxi-comparison",
    "title": "Toyota Fortuner vs Innova Crysta: Which is the Better Commercial Taxi in Delhi?",
    "excerpt": "The Fortuner commands higher fares but costs more to buy and run. The Innova Crysta offers the best balance of cost and earnings for Delhi taxi operators. Here is the complete 2026 comparison.",
    "category": "Buying Guide",
    "author": "Aditya Kumar",
    "publishedAt": "2026-05-03",
    "readTime": "8 min"
  },
  {
    "slug": "dzire-cng-mileage-real-world-taxi",
    "title": "Maruti Dzire CNG Real-World Mileage for Taxi Drivers in Delhi 2026",
    "excerpt": "Dzire CNG claims 31 km/kg on paper. Real-world taxi use in Delhi is different. Here is exactly what Delhi taxi drivers are experiencing in 2026.",
    "category": "Vehicle Reviews",
    "author": "Aditya Kumar",
    "publishedAt": "2026-05-05",
    "readTime": "5 min"
  },
  {
    "slug": "ertiga-vs-innova-7-seater-taxi-comparison",
    "title": "Maruti Ertiga vs Innova Crysta: Which 7-Seater Commercial Taxi to Buy in Delhi?",
    "excerpt": "The Ertiga costs half the Innova Crysta but earns 40% less per trip. Which 7-seater taxi makes more business sense for Delhi operators in 2026?",
    "category": "Buying Guide",
    "author": "Aditya Kumar",
    "publishedAt": "2026-05-06",
    "readTime": "7 min"
  },
  {
    "slug": "yellow-plate-taxi-registration-delhi",
    "title": "How to Register a Yellow Plate Taxi in Delhi — Complete RTO Guide 2026",
    "excerpt": "Getting a yellow plate for your taxi in Delhi involves multiple RTO steps. Here is the exact process, documents, fees, and timeline for 2026.",
    "category": "RTO & Permits",
    "author": "Aditya Kumar",
    "publishedAt": "2026-05-07",
    "readTime": "7 min"
  },
  {
    "slug": "aitp-all-india-tourist-permit-delhi",
    "title": "All India Tourist Permit (AITP) for Delhi Taxis — Cost, Documents & How to Get It",
    "excerpt": "An All India Tourist Permit (AITP) is a national permit that lets a tourist taxi carry passengers across every Indian state instead of stopping at its home border. This Buy Sell Taxi guide covers who qualifies, what it really costs under the 2023 rules, and how to apply online.",
    "category": "RTO & Permits",
    "author": "Aditya Kumar",
    "publishedAt": "2026-05-08",
    "readTime": "6 min"
  },
  {
    "slug": "innova-crysta-maintenance-cost-per-km",
    "title": "Toyota Innova Crysta Maintenance Cost Per KM — Delhi Taxi Operators Guide 2026",
    "excerpt": "Running an Innova Crysta taxi in Delhi costs ₹2–3/km in maintenance beyond fuel. Here is the exact breakdown that every buyer needs to budget for before purchasing.",
    "category": "Vehicle Reviews",
    "author": "Aditya Kumar",
    "publishedAt": "2026-05-09",
    "readTime": "6 min"
  },
  {
    "slug": "best-7-seater-taxi-under-10-lakh-delhi",
    "title": "Best 7-Seater Commercial Taxi Under ₹10 Lakh in Delhi 2026",
    "excerpt": "You do not need ₹15 lakh to start a 7-seater taxi business in Delhi. Here are the best commercial 7-seaters under ₹10 lakh in the 2026 Delhi market.",
    "category": "Buying Guide",
    "author": "Aditya Kumar",
    "publishedAt": "2026-05-10",
    "readTime": "6 min"
  },
  {
    "slug": "fortuner-taxi-monthly-earnings-delhi",
    "title": "Toyota Fortuner Taxi Monthly Earnings in Delhi — Real Numbers 2026",
    "excerpt": "A Fortuner taxi in Delhi on Uber Black can gross ₹90,000–₹1.2 lakh per month. But the net profit tells a different story. Here are the real 2026 numbers.",
    "category": "Business Tips",
    "author": "Aditya Kumar",
    "publishedAt": "2026-05-12",
    "readTime": "6 min"
  },
  {
    "slug": "ertiga-cng-running-cost-delhi",
    "title": "Maruti Ertiga CNG Running Cost for Taxi Operators in Delhi 2026",
    "excerpt": "The Ertiga CNG is the cheapest 7-seater to run in Delhi. Here is the complete per-km cost breakdown that makes it India's most economical MPV for commercial use.",
    "category": "Vehicle Reviews",
    "author": "Aditya Kumar",
    "publishedAt": "2026-05-13",
    "readTime": "5 min"
  },
  {
    "slug": "commercial-vehicle-financing-delhi-2026",
    "title": "Commercial Vehicle Financing Interest Rates in Delhi 2026 — Complete Guide",
    "excerpt": "Getting a loan for a used commercial taxi in Delhi? Here are the actual interest rates, EMI amounts, and best lenders for 2026 — from banks to NBFCs.",
    "category": "Finance",
    "author": "Aditya Kumar",
    "publishedAt": "2026-05-14",
    "readTime": "7 min"
  },
  {
    "slug": "delhi-ncr-taxi-market-report-q2-2026",
    "title": "Delhi NCR Commercial Vehicle Market Report — Q2 2026",
    "excerpt": "Based on live listing data from Buy Sell Taxi, here is what the Delhi NCR commercial vehicle market looks like in Q2 2026 — prices, trends, and top-selling models.",
    "category": "Market Insights",
    "author": "Aditya Kumar",
    "publishedAt": "2026-05-15",
    "readTime": "7 min"
  },
  {
    "slug": "second-hand-fortuner-price-delhi-2026",
    "title": "Second Hand Toyota Fortuner Price in Delhi 2026 — Commercial Market Guide",
    "excerpt": "Thinking of buying a second hand Fortuner in Delhi? Here is the year-wise price guide for used Fortuners — both commercial yellow plate and private white plate — in the Delhi NCR market in 2026.",
    "category": "Market Insights",
    "author": "Aditya Kumar",
    "publishedAt": "2026-05-16",
    "readTime": "5 min"
  },
  {
    "slug": "cng-kit-cost-innova-crysta-delhi",
    "title": "CNG Kit Cost for Toyota Innova Crysta in Delhi — Pros, Cons & Real Guide 2026",
    "excerpt": "A CNG kit for Innova Crysta costs ₹70,000–₹1,20,000 in Delhi. It saves fuel but comes with real risks. Here is everything Delhi Innova taxi operators need to know in 2026.",
    "category": "Vehicle Reviews",
    "author": "Aditya Kumar",
    "publishedAt": "2026-05-18",
    "readTime": "6 min"
  },
  {
    "slug": "fortuner-commercial-insurance-delhi-2026",
    "title": "Toyota Fortuner Commercial Vehicle Insurance in Delhi — Cost & Guide 2026",
    "excerpt": "Commercial insurance for a Fortuner taxi in Delhi costs ₹40,000–₹75,000 per year. Here is what it covers, which insurer to choose, and how to cut costs without cutting coverage.",
    "category": "Finance",
    "author": "Aditya Kumar",
    "publishedAt": "2026-05-19",
    "readTime": "5 min"
  },
  {
    "slug": "what-is-t-permit-car-buying-guide-india",
    "title": "What Is a T-Permit Car? Complete Buying Guide for India 2026",
    "excerpt": "A T-permit car is a commercial vehicle licensed to carry passengers for hire. Here is exactly what that means, how it differs from a private car, and what to check before buying one.",
    "category": "Buying Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-05-20",
    "readTime": "7 min"
  },
  {
    "slug": "t-permit-vs-private-car-buyers-guide",
    "title": "T-Permit vs Private Car: Which Should You Buy in 2026?",
    "excerpt": "The difference between a T-permit car and a private car is bigger than the plate colour. Here is a clear side-by-side on cost, rules and earning potential to help you decide.",
    "category": "Buying Guide",
    "author": "Aditya Kumar",
    "publishedAt": "2026-05-22",
    "readTime": "6 min"
  },
  {
    "slug": "buy-second-hand-commercial-car-india",
    "title": "How to Buy a Second-Hand Commercial Car in India 2026",
    "excerpt": "Buying a used commercial car is the fastest way to start a taxi business — but only if the permit and papers are clean. Here is the full, careful process for 2026.",
    "category": "Buying Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-05-24",
    "readTime": "8 min"
  },
  {
    "slug": "commercial-car-registration-process-india",
    "title": "Commercial Car Registration & Yellow Plate Process in India 2026",
    "excerpt": "Registering a car commercially turns it into a legal taxi. Here is the full yellow-plate registration process, the documents you need, and what it costs in 2026.",
    "category": "RTO & Permits",
    "author": "Aditya Kumar",
    "publishedAt": "2026-05-26",
    "readTime": "7 min"
  },
  {
    "slug": "t-permit-car-documents-checklist-india",
    "title": "T-Permit Car Documents Checklist Before You Buy (India 2026)",
    "excerpt": "Most T-permit car disputes come down to paperwork. Use this checklist to verify every document before you hand over money on a commercial car.",
    "category": "Buying Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-05-28",
    "readTime": "6 min"
  },
  {
    "slug": "convert-private-car-to-t-permit-commercial",
    "title": "How to Convert a Private Car to a T-Permit Commercial Car in India",
    "excerpt": "Already own a suitable car? You may be able to convert it from private to commercial use. Here is the eligibility, RTO process and cost of getting a T-permit in 2026.",
    "category": "RTO & Permits",
    "author": "Aditya Kumar",
    "publishedAt": "2026-05-30",
    "readTime": "7 min"
  },
  {
    "slug": "best-commercial-cars-to-buy-india-2026",
    "title": "Best Commercial Cars to Buy in India 2026",
    "excerpt": "Choosing the right commercial car decides your earnings and running cost. Here are the best T-permit cars to buy in India in 2026, sorted by use case and budget.",
    "category": "Vehicle Reviews",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-06-01",
    "readTime": "8 min"
  },
  {
    "slug": "t-permit-car-resale-value-guide-india",
    "title": "T-Permit Car Resale Value: A Buyer & Seller Guide (India 2026)",
    "excerpt": "A T-permit car holds or loses value for reasons most owners overlook. Here is what really moves resale price — and how to protect yours, whether buying or selling.",
    "category": "Selling Guide",
    "author": "Aditya Kumar",
    "publishedAt": "2026-06-02",
    "readTime": "6 min"
  },
  {
    "slug": "commercial-vs-private-car-tax-running-cost",
    "title": "Commercial vs Private Car: Tax & Running Cost Compared (2026)",
    "excerpt": "A commercial car costs more to own but is built to earn. Here is the honest tax and running-cost comparison versus a private car, so you know what you are signing up for.",
    "category": "Buying Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-06-03",
    "readTime": "7 min"
  },
  {
    "slug": "first-time-commercial-car-buyer-mistakes",
    "title": "Top Mistakes First-Time T-Permit Car Buyers Make (and How to Avoid Them)",
    "excerpt": "First commercial car purchase? These are the mistakes that cost new buyers the most money and time — and exactly how to sidestep each one.",
    "category": "Buying Guide",
    "author": "Aditya Kumar",
    "publishedAt": "2026-06-04",
    "readTime": "6 min"
  },
  {
    "id": 34,
    "slug": "used-taxi-under-1-lakh-india",
    "title": "Used Taxi Under ₹1 Lakh in India – Is It Worth Buying? (2026)",
    "excerpt": "A ₹1 lakh budget can get you on the road as a cab driver — but only if you know which vehicles are genuine value and which are money pits. Here is the honest 2026 guide.",
    "category": "Buying Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-06-10",
    "readTime": "6 min read"
  },
  {
    "id": 35,
    "slug": "taxi-on-emi-delhi",
    "title": "Buy a Taxi on EMI in Delhi – Down Payment & Loan Guide 2026",
    "excerpt": "You do not need the full amount upfront to start driving. Here is exactly how to buy a used taxi on EMI in Delhi — down payment, rates, lenders and the paperwork.",
    "category": "Finance",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-06-10",
    "readTime": "6 min read"
  },
  {
    "id": 36,
    "slug": "how-to-earn-from-taxi-india",
    "title": "How to Earn From a Taxi in India – Realistic Income Guide 2026",
    "excerpt": "Driving or owning a taxi can be a solid income — but only with the right vehicle, platform and cost discipline. Here is the realistic earning math for India in 2026.",
    "category": "Business",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-06-10",
    "readTime": "7 min read"
  },
  {
    "id": 37,
    "slug": "used-school-bus-delhi",
    "title": "Buy a Used School Bus in Delhi – Prices, Rules & Checklist 2026",
    "excerpt": "A used school bus can be a strong B2B investment for schools and transport contractors — but Delhi has strict safety norms. Here is the complete 2026 buying guide.",
    "category": "Buying Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-06-10",
    "readTime": "7 min read"
  },
  {
    "id": 38,
    "slug": "buy-tempo-traveller-mumbai",
    "title": "Buy a Used Tempo Traveller in Mumbai – Price & Guide 2026",
    "excerpt": "Tempo travellers are the backbone of Mumbai tourism, weddings and corporate transport. Here is the 2026 guide to buying a reliable used one at the right price.",
    "category": "Buying Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-06-10",
    "readTime": "6 min read"
  },
  {
    "id": 39,
    "slug": "delhi-taxi-scrappage-policy-2026",
    "title": "Delhi Taxi Scrappage Policy 2026 – Age Limits & What to Do",
    "excerpt": "Delhi NCR enforces strict vehicle age limits, and buying the wrong-age taxi can leave you with a vehicle you cannot legally run. Here is the 2026 scrappage policy made simple.",
    "category": "Legal & Permits",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-06-10",
    "readTime": "6 min read"
  },
  {
    "id": 40,
    "slug": "sell-my-taxi-online-best-price-india",
    "title": "How to Sell My Taxi Online for the Best Price in India (2026)",
    "excerpt": "Selling a taxi online is the fastest way to reach serious commercial buyers across India. Here is exactly how to list, price, and close at the best price in 2026.",
    "category": "Selling Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-06-18",
    "readTime": "7 min read"
  },
  {
    "id": 41,
    "slug": "how-much-is-my-taxi-worth-india",
    "title": "How Much Is My Taxi Worth? Resale Value Guide for India (2026)",
    "excerpt": "Before you sell, you need a realistic number. This guide explains exactly how taxi resale value is calculated in India and how to price yours right in 2026.",
    "category": "Selling Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-06-18",
    "readTime": "6 min read"
  },
  {
    "id": 42,
    "slug": "documents-required-to-sell-taxi-india",
    "title": "Documents Required to Sell a Taxi in India: Complete Checklist",
    "excerpt": "Missing paperwork is the number-one reason taxi sales fall through. Use this complete checklist to get every document ready before you list your vehicle.",
    "category": "Selling Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-06-18",
    "readTime": "6 min read"
  },
  {
    "id": 43,
    "slug": "sell-taxi-with-loan-pending-india",
    "title": "How to Sell a Taxi With a Loan Pending in India (2026 Guide)",
    "excerpt": "A pending loan does not stop you from selling your taxi. Follow this step-by-step process to clear the hypothecation, get the NOC, and transfer safely.",
    "category": "Selling Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-06-18",
    "readTime": "6 min read"
  },
  {
    "id": 44,
    "slug": "sell-used-taxi-without-broker-india",
    "title": "How to Sell a Used Taxi Without a Broker in India (Save 5–10%)",
    "excerpt": "Brokers take 5–10% of your taxi's value for work you can do yourself. Here is how to sell direct to genuine buyers and keep every rupee in 2026.",
    "category": "Selling Tips",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-06-18",
    "readTime": "6 min read"
  },
  {
    "id": 45,
    "slug": "sell-innova-crysta-taxi-best-price-india",
    "title": "How to Sell Your Innova Crysta Taxi for the Best Price in India",
    "excerpt": "The Innova Crysta is the most sought-after taxi in India and holds its value brilliantly. Here is how to sell yours for top rupee in 2026.",
    "category": "Selling Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-06-18",
    "readTime": "6 min read"
  },
  {
    "id": 46,
    "slug": "sell-dzire-taxi-best-price-india",
    "title": "How to Sell Your Swift Dzire Taxi Fast in India (Best Price Guide)",
    "excerpt": "The Maruti Swift Dzire is the backbone of India's app-cab fleet, which makes it one of the easiest taxis to sell. Here is how to do it fast and for the best price.",
    "category": "Selling Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-06-18",
    "readTime": "5 min read"
  },
  {
    "id": 47,
    "slug": "sell-taxi-mumbai-fast",
    "title": "How to Sell Your Taxi in Mumbai Fast (2026 Seller's Guide)",
    "excerpt": "Mumbai has one of India's largest taxi markets. With the right pricing, documents, and platform, you can sell your taxi here in days. Here is how.",
    "category": "Selling Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-06-18",
    "readTime": "6 min read"
  },
  {
    "id": 48,
    "slug": "taxi-gst-tax-rules-india",
    "title": "GST & Tax Rules for Taxis in India – Owner's Guide 2026",
    "excerpt": "GST, road tax and income tax quietly eat into taxi earnings. Here is a plain-English guide to what a taxi owner in India actually owes and can claim back in 2026.",
    "category": "Legal & Permits",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-07-01",
    "readTime": "7 min read"
  },
  {
    "id": 49,
    "slug": "psv-badge-commercial-licence-india",
    "title": "PSV Badge & Commercial Driving Licence in India – 2026 Guide",
    "excerpt": "A PSV (Public Service Vehicle) badge is the endorsement an Indian driver needs, on top of a commercial driving licence, to carry paying passengers — without it a taxi cannot legally operate. This Buy Sell Taxi guide covers eligibility, the Sarathi application and the documents RTOs ask for.",
    "category": "Legal & Permits",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-07-01",
    "readTime": "6 min read"
  },
  {
    "id": 50,
    "slug": "cng-vs-electric-taxi-india",
    "title": "CNG vs Electric Taxi in India 2026 – Which Should You Buy?",
    "excerpt": "CNG is the proven workhorse; electric is the low-running-cost future. Here is a clear, numbers-based comparison to decide which taxi fits your city and budget in 2026.",
    "category": "Buying Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-07-01",
    "readTime": "7 min read"
  },
  {
    "id": 51,
    "slug": "best-taxi-for-airport-rides-india",
    "title": "Best Taxi for Airport Rides in India 2026 – Top Cars & Tips",
    "excerpt": "Airport runs are among the most lucrative taxi trips — if you have the right car. Here are the best vehicles for airport service in India in 2026 and why they earn more.",
    "category": "Buying Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-07-01",
    "readTime": "6 min read"
  },
  {
    "id": 52,
    "slug": "buy-innova-crysta-taxi-bangalore",
    "title": "Buy a Used Innova Crysta Taxi in Bangalore – Price Guide 2026",
    "excerpt": "The Innova Crysta is Bangalore's favourite premium taxi for IT commutes, airport runs and outstation trips. Here is the 2026 guide to buying a reliable used one.",
    "category": "Buying Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-07-01",
    "readTime": "6 min read"
  },
  {
    "id": 53,
    "slug": "electric-taxi-subsidy-india-2026",
    "title": "Electric Taxi Subsidies in India 2026 – Incentives Explained",
    "excerpt": "Electric taxis carry a higher sticker price — but subsidies, tax waivers and permit perks can close the gap fast. Here is what support is available to EV taxi buyers in 2026.",
    "category": "Finance",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-07-01",
    "readTime": "6 min read"
  },
  {
    "id": 54,
    "slug": "convert-t-permit-to-private-car-india",
    "title": "Convert T Permit Car to Private (White Plate) in India – 2026 Guide",
    "excerpt": "T permit cars sell 20–40% cheaper than private ones — which is exactly why so many buyers want to convert one to a white plate. Here is the real process, cost and the catches.",
    "category": "Legal & Permits",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-07-02",
    "readTime": "7 min read"
  },
  {
    "id": 55,
    "slug": "t-permit-cost-renewal-validity-india",
    "title": "T Permit Cost, Validity & Renewal in India – Complete 2026 Guide",
    "excerpt": "Every commercial car owner pays for the T permit twice: once to get it, and every few years to keep it. Here is what it actually costs, how long it lasts, and how to renew on time.",
    "category": "Legal & Permits",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-07-02",
    "readTime": "6 min read"
  },
  {
    "id": 56,
    "slug": "best-t-permit-cars-india-2026",
    "title": "Best T Permit Cars to Buy in India 2026 – Top 8 Ranked",
    "excerpt": "Not every car survives commercial duty. These 8 T permit cars have proven themselves on Indian roads for running cost, durability and resale — ranked for 2026.",
    "category": "Buying Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-07-02",
    "readTime": "7 min read"
  },
  {
    "id": 57,
    "slug": "t-permit-car-loan-finance-india",
    "title": "T Permit Car Loan in India – How to Finance a Commercial Car 2026",
    "excerpt": "Financing a T permit car works differently from a private car loan — different lenders, rates and paperwork. Here is exactly how to get a commercial car funded in 2026.",
    "category": "Finance",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-07-02",
    "readTime": "6 min read"
  },
  {
    "id": 58,
    "slug": "commercial-vehicle-permit-types-india",
    "title": "Commercial Vehicle Permit Types in India – All Permits Explained 2026",
    "excerpt": "Buying a commercial vehicle with the wrong permit is an expensive mistake. Here is every Indian commercial permit type explained — and which one your work actually needs.",
    "category": "Legal & Permits",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-07-02",
    "readTime": "7 min read"
  },
  {
    "id": 59,
    "slug": "used-commercial-vehicle-inspection-checklist-india",
    "title": "Used Commercial Vehicle Inspection Checklist – 25 Points (2026)",
    "excerpt": "Commercial vehicles hide their abuse well. This 25-point checklist — mechanical, documents and fraud checks — is how professional buyers inspect before paying.",
    "category": "Buying Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-07-02",
    "readTime": "8 min read"
  },
  {
    "id": 60,
    "slug": "best-used-commercial-vehicles-under-5-lakh-india",
    "title": "Best Used Commercial Vehicles Under ₹5 Lakh in India (2026)",
    "excerpt": "Five lakh is the sweet spot of India's used commercial market — enough for a genuinely good earner in every category. Here are the best buys for 2026.",
    "category": "Buying Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-07-02",
    "readTime": "7 min read"
  },
  {
    "id": 61,
    "slug": "gst-on-buying-commercial-vehicle-india",
    "title": "GST on Buying a Commercial Vehicle in India – ITC Rules 2026",
    "excerpt": "GST on the vehicle purchase itself — and whether you can claim it back — changes the real cost of a commercial vehicle by lakhs. Here are the 2026 rules made simple.",
    "category": "Finance",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-07-02",
    "readTime": "6 min read"
  },
  {
    "id": 62,
    "slug": "used-dzire-tour-for-sale-india",
    "title": "Used Dzire Tour for Sale in India – Price & Buying Guide 2026",
    "excerpt": "The Maruti Dzire Tour S is India's highest-selling dedicated taxi. Here is what a used one costs in 2026, how it differs from the regular Dzire, and what to check.",
    "category": "Buying Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-07-02",
    "readTime": "6 min read"
  },
  {
    "id": 63,
    "slug": "used-ertiga-tour-for-sale-india",
    "title": "Used Ertiga Tour for Sale in India – Price & Buying Guide 2026",
    "excerpt": "The Ertiga Tour M is the 7-seater that powers India's family-taxi and outstation segment. Here is what a used one costs in 2026 and how to buy a good one.",
    "category": "Buying Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-07-02",
    "readTime": "6 min read"
  },
  {
    "id": 64,
    "slug": "yellow-number-plate-cars-for-sale-india",
    "title": "Yellow Number Plate Cars for Sale in India – Buyer's Guide 2026",
    "excerpt": "Yellow plate cars sell 20–40% cheaper than white plate ones — and for the right buyer they are the smarter purchase. Here is everything about buying one in 2026.",
    "category": "Buying Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-07-02",
    "readTime": "6 min read"
  },
  {
    "id": 65,
    "slug": "taxi-with-permit-for-sale-india",
    "title": "Taxi with Permit for Sale in India – Why It's Worth More (2026)",
    "excerpt": "A taxi sold with a live permit can earn from day one — no RTO queues, no waiting. Here is what permit-included taxis cost and how to verify the permit is real.",
    "category": "Buying Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-07-02",
    "readTime": "6 min read"
  },
  {
    "id": 66,
    "slug": "certified-used-taxi-india",
    "title": "Certified Used Taxi in India – Why Certification Matters (2026)",
    "excerpt": "In a market full of doctored odometers and hidden accident repairs, certification is the difference between buying a taxi and buying a problem. Here is what it means in 2026.",
    "category": "Buying Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-07-02",
    "readTime": "6 min read"
  },
  {
    "id": 67,
    "slug": "used-wagonr-taxi-for-sale-india",
    "title": "Used WagonR Taxi for Sale in India – Price & Guide 2026",
    "excerpt": "The WagonR CNG is the lowest-cost reliable taxi in India — the default first commercial car for owner-drivers. Here is the used-market picture for 2026.",
    "category": "Buying Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-07-02",
    "readTime": "6 min read"
  },
  {
    "id": 68,
    "slug": "celerio-tour-h3-taxi-india",
    "title": "Celerio Tour H3 Taxi – Used Price & Buying Guide India 2026",
    "excerpt": "The Celerio Tour H3 is Maruti's fleet-spec hatchback — an AMT-available, CNG-frugal city cab. Here is the used market guide for 2026.",
    "category": "Buying Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-07-02",
    "readTime": "5 min read"
  },
  {
    "id": 69,
    "slug": "ola-uber-taxi-for-sale-india",
    "title": "Ola & Uber Taxi for Sale in India – Attached Cars Guide 2026",
    "excerpt": "An \"Ola/Uber taxi for sale\" can mean a ready-to-earn app cab — or a worn fleet retiral. Here is how to tell the difference and what attachment really transfers.",
    "category": "Buying Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-07-02",
    "readTime": "6 min read"
  },
  {
    "id": 70,
    "slug": "buy-taxi-agra",
    "title": "Buy Taxi in Agra 2026 – Used Taxis for Sale for Taj Tourism Routes",
    "excerpt": "Agra runs on tourism — 7 million+ visitors a year need airport pickups, Taj corridor transfers and same-day Delhi trips. Here is the complete guide to buying a taxi in Agra in 2026.",
    "category": "City Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-07-03",
    "readTime": "5 min read"
  },
  {
    "id": 71,
    "slug": "buy-taxi-vadodara",
    "title": "Buy Taxi in Vadodara 2026 – Used CNG Taxis for Sale in Baroda",
    "excerpt": "Vadodara sits on Gujarat's industrial spine between Ahmedabad and Surat, with one of India's best CNG networks. Here is the 2026 guide to buying a taxi in Baroda.",
    "category": "City Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-07-03",
    "readTime": "5 min read"
  },
  {
    "id": 72,
    "slug": "buy-taxi-indore",
    "title": "Buy Taxi in Indore 2026 – Used Taxis for Sale in MP's App-Cab Capital",
    "excerpt": "Indore is Madhya Pradesh's commercial capital and one of India's fastest-growing tier-2 app-cab markets. Here is the complete 2026 guide to buying a taxi in Indore.",
    "category": "City Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-07-03",
    "readTime": "5 min read"
  },
  {
    "id": 73,
    "slug": "buy-taxi-nagpur",
    "title": "Buy Taxi in Nagpur 2026 – Used Taxis for Sale in the Orange City",
    "excerpt": "Nagpur sits at India's geographic centre with MIHAN, a growing metro and a rising app-cab market. Here is the complete 2026 guide to buying a taxi in Nagpur.",
    "category": "City Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-07-03",
    "readTime": "5 min read"
  },
  {
    "id": 74,
    "slug": "buy-taxi-chandigarh",
    "title": "Buy Taxi in Chandigarh 2026 – Used Taxis for Sale in the Tricity",
    "excerpt": "Chandigarh's taxi market spans three cities and three registrations — Chandigarh, Mohali and Panchkula. Here is the complete 2026 guide to buying a taxi in the tricity.",
    "category": "City Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-07-03",
    "readTime": "5 min read"
  },
  {
    "id": 75,
    "slug": "buy-cng-taxi-ahmedabad",
    "title": "Buy CNG Taxi in Ahmedabad 2026 – Prices, Models & Gujarat CNG Advantage",
    "excerpt": "Gujarat has India's densest CNG network, and Ahmedabad is its biggest taxi market. Here is why a CNG taxi is the default choice in Ahmedabad — and how to buy one right in 2026.",
    "category": "Buying Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-07-03",
    "readTime": "5 min read"
  },
  {
    "id": 76,
    "slug": "used-alto-taxi-for-sale-india",
    "title": "Used Alto Taxi for Sale in India – 2026 Price Guide & Buying Tips",
    "excerpt": "The Maruti Alto remains India's cheapest entry into the taxi business. Here is what a used Alto taxi costs in 2026, which variant to pick, and how to buy one safely.",
    "category": "Buying Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-07-03",
    "readTime": "5 min read"
  },
  {
    "id": 77,
    "slug": "used-aura-taxi-for-sale-india",
    "title": "Used Hyundai Aura Taxi for Sale in India – 2026 Price & Review",
    "excerpt": "The Hyundai Aura has become a strong CNG sedan alternative to the Dzire for app-based cab drivers. Here is the 2026 price and buying guide for a used Aura taxi.",
    "category": "Buying Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-07-03",
    "readTime": "5 min read"
  },
  {
    "id": 78,
    "slug": "used-rumion-taxi-for-sale-india",
    "title": "Used Toyota Rumion Taxi for Sale in India – 2026 Price & Buying Guide",
    "excerpt": "The Toyota Rumion — Toyota's badge-engineered version of the Ertiga — is gaining traction with taxi operators who want Maruti's platform with Toyota's service reputation. Here is the 2026 buying guide.",
    "category": "Buying Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-07-03",
    "readTime": "5 min read"
  },
  {
    "id": 79,
    "slug": "used-bolero-neo-taxi-for-sale-india",
    "title": "Used Mahindra Bolero Neo Taxi for Sale in India – 2026 Price Guide",
    "excerpt": "The Bolero Neo is a favourite for taxi operators running rural and semi-urban routes where toughness matters more than fuel economy. Here is the 2026 buying guide.",
    "category": "Buying Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-07-03",
    "readTime": "5 min read"
  },
  {
    "id": 80,
    "slug": "commercial-taxi-for-sale-india",
    "title": "Commercial Taxi for Sale in India – 2026 Buyer's Guide",
    "excerpt": "A commercial taxi purchase in India involves more than picking a car — permit type, registration category and documentation all shape your total cost and earning potential. Here is the complete 2026 guide.",
    "category": "Buying Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-07-03",
    "readTime": "6 min read"
  },
  {
    "id": 81,
    "slug": "taxi-dealers-india",
    "title": "Taxi Dealers in India – How to Find Trustworthy Commercial Car Dealers (2026)",
    "excerpt": "Local taxi dealers and commercial car dealers vary hugely in reliability across India. Here is how to tell a trustworthy dealer from a risky one, and why more buyers are switching to verified online marketplaces.",
    "category": "Buying Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-07-03",
    "readTime": "5 min read"
  },
  {
    "id": 82,
    "slug": "taxi-exchange-india",
    "title": "Taxi Exchange in India – Upgrade Your Old Taxi the Smart Way (2026)",
    "excerpt": "Exchanging an old taxi against a newer one saves weeks of selling hassle — but trade-in offers are often 15–25% below market. Here is how to exchange smart in 2026.",
    "category": "Selling Tips",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-07-04",
    "readTime": "6 min read"
  },
  {
    "id": 83,
    "slug": "taxi-classifieds-india",
    "title": "Taxi Classifieds in India – Where to List & Find Taxis in 2026",
    "excerpt": "Taxi classifieds are scattered across OLX, Quikr, Facebook groups and dealer WhatsApp lists — each with different buyers and different scams. Here is the 2026 map.",
    "category": "Selling Tips",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-07-04",
    "readTime": "6 min read"
  },
  {
    "id": 84,
    "slug": "buy-fleet-vehicles-india",
    "title": "Buy Fleet Vehicles in India – Used Fleet Cars Guide 2026",
    "excerpt": "Whether you're building a 5-cab fleet or buying retired fleet cars at a discount, the economics differ from single-vehicle deals. Here is the 2026 fleet buyer's guide.",
    "category": "Business",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-07-04",
    "readTime": "7 min read"
  },
  {
    "id": 85,
    "slug": "buy-innova-hycross-taxi-india",
    "title": "Buy Innova Hycross Taxi in India 2026 – Price, Mileage & Review",
    "excerpt": "The Innova Hycross is the first serious hybrid challenger in India's premium taxi segment. Here is what a used one costs in 2026 and whether it beats the Crysta for commercial use.",
    "category": "Buying Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-08-22",
    "readTime": "7 min read"
  },
  {
    "id": 86,
    "slug": "used-camry-taxi-for-sale-india",
    "title": "Used Toyota Camry Taxi for Sale in India – Executive Cab Guide 2026",
    "excerpt": "The executive taxi segment is small, quiet and unusually profitable. Here is what a used Toyota Camry costs as a commercial vehicle and which contracts actually pay for it.",
    "category": "Vehicle Review",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-08-22",
    "readTime": "6 min read"
  },
  {
    "id": 87,
    "slug": "buy-honda-amaze-taxi-india",
    "title": "Buy Honda Amaze Taxi in India 2026 – Price, Mileage & Review",
    "excerpt": "The Honda Amaze is the most underrated compact taxi in India — bigger boot than a Dzire, better ride, and a diesel engine that returns 25 kmpl. Here is what a used one costs.",
    "category": "Buying Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-08-22",
    "readTime": "6 min read"
  },
  {
    "id": 88,
    "slug": "used-xcent-taxi-for-sale-india",
    "title": "Used Hyundai Xcent Taxi for Sale in India – Price & Review 2026",
    "excerpt": "The Hyundai Xcent Prime was built specifically for fleet operators, which is why so many are now reaching the used market at attractive prices. Here is what to pay and what to check.",
    "category": "Vehicle Review",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-08-22",
    "readTime": "6 min read"
  },
  {
    "id": 89,
    "slug": "used-taxi-price-list-india-2026",
    "title": "Used Taxi Price List in India 2026 – Model-Wise Rates & Budgets",
    "excerpt": "What should you actually pay for a used taxi in India in 2026? A model-wise price list across every budget band, plus how much prices swing between cities.",
    "category": "Buying Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-08-22",
    "readTime": "8 min read"
  },
  {
    "id": 90,
    "slug": "best-mileage-taxi-cars-india",
    "title": "Best Mileage Taxi Cars in India 2026 – Real Cost Per Kilometre",
    "excerpt": "Fuel is the largest controllable cost in any taxi business. Here is what each popular taxi actually returns in commercial use, converted into rupees per kilometre.",
    "category": "Vehicle Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-08-22",
    "readTime": "7 min read"
  },
  {
    "id": 91,
    "slug": "best-taxi-for-outstation-india",
    "title": "Best Taxi for Outstation Trips in India 2026 – Cars & Earnings",
    "excerpt": "Outstation work pays better per kilometre than city driving and involves far less traffic. Here are the vehicles that suit it, what they earn, and the permit you cannot skip.",
    "category": "Vehicle Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-08-22",
    "readTime": "7 min read"
  },
  {
    "id": 92,
    "slug": "taxi-price-negotiation-tips-india",
    "title": "How to Negotiate a Used Taxi Price in India – 9 Tactics That Work",
    "excerpt": "Most used taxi buyers negotiate on instinct and lose. Here is how to build a price case from the vehicle's actual condition, with rupee values for each defect you find.",
    "category": "Buying Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-08-22",
    "readTime": "7 min read"
  },
  {
    "id": 93,
    "slug": "taxi-down-payment-guide-india",
    "title": "Taxi Down Payment in India 2026 – How Much You Really Need",
    "excerpt": "The down payment is the single biggest barrier to owning a commercial vehicle. Here is what lenders actually ask for in 2026, and the legitimate ways to bring it down.",
    "category": "Finance Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-08-22",
    "readTime": "6 min read"
  },
  {
    "id": 94,
    "slug": "low-maintenance-taxi-cars-india",
    "title": "Lowest Maintenance Taxi Cars in India 2026 – Annual Cost Compared",
    "excerpt": "Fuel gets all the attention, but maintenance is what quietly decides whether a taxi is profitable. Here is what each popular model actually costs to keep on the road for a year.",
    "category": "Vehicle Guide",
    "author": "Buy Sell Taxi Team",
    "publishedAt": "2026-08-22",
    "readTime": "7 min read"
  }
];

/** Newest first, optionally excluding the post being viewed. */
export const getLatestPosts = (count = 3, excludeSlug = '') =>
  blogIndex
    .filter((p) => p.slug !== excludeSlug)
    .slice(-count)
    .reverse();

export default blogIndex;
